@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
@if (user?.hasPerm('admin.add_logentry')) {
  @for (activity of activities; track activity) {
    <div class="backgroundSquares fadeIn"
      [style.background-image]="'url(' + activity?.meta?.imageUrl + ')'"
      [@zoomBack]=$safeNavigationMigration(user?.app_state?.homeBackground)
      [style.animation-delay]="'0.' +activity?.meta?.timing + 's'" (click)="utils.sound('click-face')">
      <div fxlayout="row">
        <div class="title" [routerLink]="'/posts/' + activity.name">
          {{ activity.name }}
        </div>
        @if (!activity?.is_premium) {
          <mat-icon (click)="adminTogglePremium(activity)" matTooltip="Toggle Premium" class="premium">star_border</mat-icon>
        }
        @if (activity?.is_premium) {
          <mat-icon (click)="adminTogglePremium(activity)" matTooltip="Toggle Premium" class="premium">star</mat-icon>
        }
        @if (activity?.url != null) {
          <button mat-button class="help" (click)="openExternal($safeNavigationMigration(activity?.url))"><mat-icon>help</mat-icon></button>
        }
      </div>
      <button mat-button class="adminBtn" (click)="imageInput.click()"><mat-icon>add_a_photo</mat-icon></button>
      @if (activity['images'] && activity['images'].photos.length > 0 && activity.meta.image != null && activity.meta.image.image.sm != null) {
        <button mat-button class="adminBtn" (click)="adminDeletePhoto(activity)"><mat-icon>delete</mat-icon></button>
      }
      <input hidden (change)="adminProcessFile(imageInput, activity)" #imageInput type="file" accept="image/*">
      <button mat-button class="adminBtn" (click)="activity.meta.showUrl=true"><mat-icon>help</mat-icon></button>
      @if (activity.meta.showUrl) {
        <form [formGroup]="form" (ngSubmit)="adminSaveUrl(activity)" class="urlBox">
          <mat-form-field>
            <input matInput placeholder="Url" type="text" class="form-control" [(ngModel)]="activity.url" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
          <button mat-button (click)="adminSaveUrl(activity)"><mat-icon>save</mat-icon>Save</button>
        </form>
      }
    </div>
  }
}

<!-- <ng-container  *ngIf="!user?.hasPerm('admin.add_logentry') && activities.length != 0"> -->
@if (!user?.hasPerm('admin.add_logentry')) {
  @if (searchStr == '' && (router.url == '/activities' || router.url == '/search/activities')) {
    <div class="tags">
      @for (tag of tags; track tag.slug) {
        <button mat-button class="tag" [class.on]="tagSelected(tag.slug)" (click)="toggleTag(tag.slug)">{{tag.name}}</button>
      }
      <button mat-button class="tag" [class.on]="flags.popular" (click)="togglePopular()">popular</button>
    </div>
  }
  <div  (swipeleft)="swipeLeft()">
    @if (activities.length != 0) {
      <div class="resultsHeader" [class.on]="searchStr != null"><mat-icon>accessibility_new</mat-icon> Activities</div>
    }
    @for (activity of activities; track activity; let i = $index) {
      <a class="backgroundSquares fadeIn"
        [style.background-image]="'url(' + activity.meta.imageUrl + ')'"
        [@zoomBack]=$safeNavigationMigration(user?.app_state?.homeBackground) [routerLink]="'/activity/' + activity.slug"
        [style.animation-delay]="'0.' +activity?.meta?.timing + 's'" (click)="utils.sound('click-face')" [class.one]="nth(i,3)" [class.three]="nth(i+1,3)">
        <div fxlayout="row">
          <div class="title">
            {{ activity.name }}
          </div>
          @if (activity?.is_premium) {
            <mat-icon matTooltip="Premium Activity" class="premium">star</mat-icon>
          }
        </div>
      </a>
    }
    @if ((searchStr == null || searchStr == '') && flags.noResults && !flags.loading) {
      <div class="noResults">
        <h2><mat-icon>accessibility_new</mat-icon></h2>
        <h5>No more activities found</h5>
        <br /><br />
        @if (searchStr) {
          <button mat-button routerLink="/activities" (click)="searchStr=null;getActivities()"><mat-icon>arrow_back</mat-icon> Back</button>
        }
        <br /><br />
      </div>
    }
  </div>
}
